import { createStore } from "redux";
import { applyMiddleware } from "redux";
import { thunk } from 'redux-thunk';
import Reducers from "VENDOR/Reducers/Reducers";


const Store = createStore(
    Reducers,
    applyMiddleware(thunk)
    
);

export default Store;